function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#525F7F",
  fillRule: "evenodd",
  d: "M15.135 8.862L4.507 15.114A1 1 0 013 14.252V1.748A1 1 0 014.507.886l10.628 6.252a1 1 0 010 1.724z"
});

function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8cGF0aCBmaWxsPSIjNTI1RjdGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS4xMzQ3MTE4LDguODYxOTM0MjIgTDQuNTA3MDIwMTMsMTUuMTEzNTE3NiBDNC4wMzA5ODcsMTUuMzkzNTM3MSAzLjQxODA4NTI3LDE1LjIzNDYzNjYgMy4xMzgwNjU3OCwxNC43NTg2MDM1IEMzLjA0NzY2Nzc2LDE0LjYwNDkyNjggMywxNC40Mjk4NzYxIDMsMTQuMjUxNTgzNCBMMywxLjc0ODQxNjY0IEMzLDEuMTk2MTMxODkgMy40NDc3MTUyNSwwLjc0ODQxNjY0MyA0LDAuNzQ4NDE2NjQzIEM0LjE3ODI5Mjc4LDAuNzQ4NDE2NjQzIDQuMzUzMzQzNDgsMC43OTYwODQ0IDQuNTA3MDIwMTMsMC44ODY0ODI0MjcgTDE1LjEzNDcxMTgsNy4xMzgwNjU3OCBDMTUuNjEwNzQ1LDcuNDE4MDg1MjcgMTUuNzY5NjQ1NCw4LjAzMDk4NyAxNS40ODk2MjU5LDguNTA3MDIwMTMgQzE1LjQwMzQxNzksOC42NTM1NzM3OSAxNS4yODEyNjU1LDguNzc1NzI2MTggMTUuMTM0NzExOCw4Ljg2MTkzNDIyIFoiLz4KPC9zdmc+Cg==";
export { SvgPlay as ReactComponent };